import Accordion from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import {
  DeliveryOption,
  DeliveryOptions,
} from "./DeliveryOptions/DeliveryOptions";
import { ProductDeliveryReturns } from "./ProductDeliveryReturns/ProductDeliveryReturns";
import { ExtendedReturnsPolicy } from "./ExtendedReturnsPolicy/ExtendedReturnsPolicy";

export const PRODUCT_DELIVERY_OPTIONS_ACCORDION_INSTANCE_NAME =
  "product-delivery-options";
export type ReturnsDateObj = Record<"year" | "month" | "date", number>;
export type Props = {
  deliveryOptions: DeliveryOption[];
  skuId: string;
  isAvailableToOrderOrPreorder: boolean;
  stockApiBaseUrl: string;
  stockApiKey: string;
  isInExtendedReturnsWindow: boolean;
  isRetired: boolean;
  isInStoreOnly: boolean;
  isM2M: boolean;
  isMeteredProduct?: boolean;
  open?: boolean;
  browsePageHierarchy: Array<{ categoryId: string }>;
  sellingProductType?: string;
  showChristmasDeliveryMessaging: boolean;
  showOutletReturnMessage?: boolean;
  isBladedArticle?: boolean;
  returnsStartDate?: string;
  returnsEndDate?: string;
};

export function ProductDeliveryOptionsAccordionUI({
  deliveryOptions,
  skuId,
  isAvailableToOrderOrPreorder,
  stockApiBaseUrl,
  stockApiKey,
  isInExtendedReturnsWindow,
  isInStoreOnly,
  isRetired,
  isM2M,
  isMeteredProduct,
  open,
  browsePageHierarchy,
  sellingProductType = "",
  showOutletReturnMessage = false,
  isBladedArticle = false,
  returnsStartDate,
  returnsEndDate,
  showChristmasDeliveryMessaging,
}: Props) {
  if (isRetired) return null;
  if (isInStoreOnly) return null;

  return (
    <Accordion
      id="accordion-delivery"
      data-testid="accordion:delivery"
      label="Delivery and returns"
      animated={true}
      instanceName={PRODUCT_DELIVERY_OPTIONS_ACCORDION_INSTANCE_NAME}
      responsive
      open={open}
    >
      {deliveryOptions.length > 0 && (
        <DeliveryOptions
          skuId={skuId}
          isAvailableToOrderOrPreorder={isAvailableToOrderOrPreorder}
          deliveryOptions={deliveryOptions}
          stockApiBaseUrl={stockApiBaseUrl}
          stockApiKey={stockApiKey}
        />
      )}
      <ProductDeliveryReturns
        browsePageHierarchy={browsePageHierarchy}
        sellingProductType={sellingProductType}
        showOutletReturnsMessage={showOutletReturnMessage}
        isBladedArticle={isBladedArticle}
        isM2M={isM2M}
        returnsStartDate={returnsStartDate}
        returnsEndDate={returnsEndDate}
        isMeteredProduct={isMeteredProduct}
        showChristmasDeliveryMessaging={showChristmasDeliveryMessaging}
      />
      {isInExtendedReturnsWindow && <ExtendedReturnsPolicy />}
    </Accordion>
  );
}
